
/**
 * Spirec Stock Indicator
 * 
 * Visuell markering av slutsålda produkter i varukorgen.
 * Pollar lagerstatus regelbundet och markerar slutsålda items.
 * 
 * SÄKERHET:
 * - Tar ALDRIG bort produkter från varukorgen
 * - Ändrar ALDRIG cart-data
 * - Påverkar INTE checkout-knappen
 * - Vid network errors visas inget felmeddelande
 * 
 * Kör på:
 * - Cart-sidan (/cart)
 * - När cart-drawern är öppen
 */

(function() {
  'use strict';
  
  var DEBUG = true;
  var POLL_INTERVAL_MS = 30000; // 30 sekunder
  var CHECK_ON_LOAD_DELAY_MS = 1000; // 1 sek efter sidan laddats
  
  var pollingTimer = null;
  var isPolling = false;
  var soldOutKeys = new Set(); // håller koll på vilka items som är slutsålda
  
  function log() {
    if (DEBUG) console.log.apply(console, ['[Spirec Stock]'].concat(Array.from(arguments)));
  }
  
  /**
   * Hämtar färsk cart-data
   */
  function fetchCart() {
    return fetch('/cart.js?_=' + Date.now(), {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    })
    .then(function(r) { return r.json(); })
    .catch(function(err) {
      log('Cart fetch failed (silently ignored):', err);
      return null;
    });
  }
  
  /**
   * Hämtar färsk product-data
   */
  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js?_=' + Date.now(), {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    })
    .then(function(r) {
      if (!r.ok) return null;
      return r.json();
    })
    .catch(function(err) {
      log('Product fetch failed for', handle, '(silently ignored):', err);
      return null;
    });
  }
  
  /**
   * Kollar status på alla cart-items
   * Returnerar { soldOut: [item-keys], partial: [item-keys] }
   */
  function checkCartStatus() {
    return fetchCart().then(function(cart) {
      if (!cart || !cart.items || cart.items.length === 0) {
        return { soldOut: [], partial: [] };
      }
      
      var uniqueHandles = [];
      cart.items.forEach(function(item) {
        if (uniqueHandles.indexOf(item.handle) === -1) {
          uniqueHandles.push(item.handle);
        }
      });
      
      var productPromises = uniqueHandles.map(function(handle) {
        return fetchProduct(handle).then(function(product) {
          return { handle: handle, product: product };
        });
      });
      
      return Promise.all(productPromises).then(function(results) {
        var productMap = {};
        results.forEach(function(r) {
          if (r.product) productMap[r.handle] = r.product;
        });
        
        var soldOut = [];
        var partial = [];
        
        cart.items.forEach(function(item) {
          var product = productMap[item.handle];
          
          // Om vi inte kunde hämta produkt-data, hoppa över (säker fallback)
          if (!product) return;
          
          var variant = product.variants.find(function(v) {
            return v.id === item.variant_id;
          });
          
          // Om variant inte finns, markera som slutsåld
          if (!variant) {
            soldOut.push(item.key);
            return;
          }
          
          // Om variant är oavailable, markera som slutsåld
          if (!variant.available) {
            soldOut.push(item.key);
            return;
          }
          
          // Om lagret är mindre än antalet i varukorgen, partial
          if (variant.inventory_management === 'shopify' &&
              variant.inventory_policy === 'deny' &&
              typeof variant.inventory_quantity === 'number' &&
              variant.inventory_quantity < item.quantity) {
            partial.push({
              key: item.key,
              available: variant.inventory_quantity,
              requested: item.quantity
            });
          }
        });
        
        return { soldOut: soldOut, partial: partial };
      });
    });
  }
  
  /**
   * Lägger till visuell markering på en cart-rad
   */
  function markItemSoldOut(itemKey) {
    var elements = document.querySelectorAll('[data-cart-item-key="' + itemKey + '"]');
    
    elements.forEach(function(el) {
      var wrapper = el.closest('.cart-item__wrapper, .cart-drawer__item__wrapper');
      if (wrapper && !wrapper.classList.contains('spirec-soldout')) {
        wrapper.classList.add('spirec-soldout');
        log('Marked sold out:', itemKey);
      }
    });
  }
  
  /**
   * Tar bort visuell markering från en cart-rad
   */
  function unmarkItemSoldOut(itemKey) {
    var elements = document.querySelectorAll('[data-cart-item-key="' + itemKey + '"]');
    
    elements.forEach(function(el) {
      var wrapper = el.closest('.cart-item__wrapper, .cart-drawer__item__wrapper');
      if (wrapper && wrapper.classList.contains('spirec-soldout')) {
        wrapper.classList.remove('spirec-soldout');
        log('Unmarked sold out:', itemKey);
      }
    });
  }
  
  /**
   * Uppdaterar visuell status baserat på check-resultatet
   */
  function applyStatus(status) {
    var newSoldOut = new Set(status.soldOut);
    
    // Markera nya slutsålda
    status.soldOut.forEach(function(key) {
      if (!soldOutKeys.has(key)) {
        markItemSoldOut(key);
      }
    });
    
    // Avmarkera som inte längre är slutsålda
    soldOutKeys.forEach(function(key) {
      if (!newSoldOut.has(key)) {
        unmarkItemSoldOut(key);
      }
    });
    
    soldOutKeys = newSoldOut;
  }
  
  /**
   * Injicerar CSS för slutsåld-stilar
   */
function injectStyles() {
    if (document.getElementById('spirec-stock-styles')) return;
    
    var css = 
      '.spirec-soldout {' +
      '  background: rgba(185, 28, 28, 0.06) !important;' +
      '  border-left: 3px solid #b91c1c !important;' +
      '  position: relative;' +
      '}' +
      '.spirec-soldout .cart-item__title {' +
      '  text-decoration: line-through;' +
      '  color: #999 !important;' +
      '}' +
      '.spirec-soldout .cart-item__title::after {' +
      '  content: " — TYVÄRR SLUTSÅLD";' +
      '  color: #b91c1c !important;' +
      '  font-weight: 800;' +
      '  text-decoration: none;' +
      '  display: inline-block;' +
      '  margin-left: 6px;' +
      '  font-size: 0.9em;' +
      '  letter-spacing: 0.04em;' +
      '}' +
      '.spirec-soldout .cart-item__image-wrapper {' +
      '  filter: grayscale(0.8);' +
      '  opacity: 0.6;' +
      '}' +
      '.spirec-soldout .cart-item__quantity,' +
      '.spirec-soldout .cart-item__price-wrapper,' +
      '.spirec-soldout .cart-item__line-price-wrapper > .cart-item__line-price-wrapper {' +
      '  opacity: 0.5;' +
      '}' +
      '.spirec-soldout .cart-item__remove {' +
      '  opacity: 1 !important;' +
      '}' +
      '.spirec-remove-btn {' +
      '  display: inline-flex !important;' +
      '  align-items: center;' +
      '  gap: 6px;' +
      '  background: #b91c1c;' +
      '  color: #ffffff !important;' +
      '  border: none;' +
      '  border-radius: 6px;' +
      '  padding: 7px 12px;' +
      '  font-size: 11.5px;' +
      '  font-weight: 700;' +
      '  text-transform: uppercase;' +
      '  letter-spacing: 0.05em;' +
      '  cursor: pointer;' +
      '  font-family: inherit;' +
      '  transition: background 0.15s, transform 0.15s;' +
      '  white-space: nowrap;' +
      '  margin-top: 8px;' +
      '  -webkit-tap-highlight-color: transparent;' +
      '  text-decoration: none !important;' +
      '  line-height: 1.2;' +
      '  opacity: 1 !important;' +
      '}' +
      '.spirec-remove-btn:hover {' +
      '  background: #991818;' +
      '  color: #ffffff !important;' +
      '  transform: translateY(-1px);' +
      '}' +
      '.spirec-remove-btn:active {' +
      '  transform: scale(0.98);' +
      '}' +
      '.spirec-remove-btn svg {' +
      '  width: 12px;' +
      '  height: 12px;' +
      '  fill: #ffffff;' +
      '  flex-shrink: 0;' +
      '}' +
      '@media (max-width: 720px) {' +
      '  .spirec-soldout .cart-item__title::after {' +
      '    display: block;' +
      '    margin-left: 0;' +
      '    margin-top: 2px;' +
      '  }' +
      '  .spirec-remove-btn {' +
      '    font-size: 10.5px;' +
      '    padding: 6px 10px;' +
      '  }' +
      '}';
    
    var style = document.createElement('style');
    style.id = 'spirec-stock-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }
  
  /**
   * Kör en koll och uppdaterar UI
   */
  function runCheck() {
    log('Running stock check');
    checkCartStatus()
      .then(function(status) {
        log('Status:', status);
        applyStatus(status);
      })
      .catch(function(err) {
        log('Check failed (silently ignored):', err);
      });
  }
  
  /**
   * Startar polling
   */
  function startPolling() {
    if (isPolling) return;
    isPolling = true;
    
    log('Starting polling every', POLL_INTERVAL_MS / 1000, 'seconds');
    
    // Initial check efter kort delay (låter sidan ladda färdigt)
    setTimeout(runCheck, CHECK_ON_LOAD_DELAY_MS);
    
    // Sen var 30:e sekund
    pollingTimer = setInterval(runCheck, POLL_INTERVAL_MS);
  }
  
  /**
   * Stoppar polling
   */
  function stopPolling() {
    if (!isPolling) return;
    isPolling = false;
    
    if (pollingTimer) {
      clearInterval(pollingTimer);
      pollingTimer = null;
    }
    
    log('Stopped polling');
  }
  
  /**
   * Avgör om vi ska polla just nu
   */
  function shouldPoll() {
    // På cart-sidan: alltid
    if (window.location.pathname === '/cart' || window.location.pathname === '/cart/') {
      return true;
    }
    
    // Om cart-drawer är öppen
    var drawer = document.querySelector('cart-drawer[open]');
    if (drawer) return true;
    
    // Annars: nej
    return false;
  }
  
  /**
   * Uppdaterar polling-status baserat på sidans tillstånd
   */
  function updatePolling() {
    if (shouldPoll()) {
      startPolling();
    } else {
      stopPolling();
    }
  }
  
  /**
   * Hanterar att drawern öppnas/stängs
   */
  function watchDrawer() {
    // Använd MutationObserver för att se när drawern ändrar state
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) {
      // Om drawern inte finns ännu, vänta lite och försök igen
      setTimeout(watchDrawer, 1000);
      return;
    }
    
    var observer = new MutationObserver(function() {
      updatePolling();
      
      // Om drawern just öppnats, kör en extra check direkt
      if (drawer.hasAttribute('open')) {
        setTimeout(runCheck, 300);
      }
    });
    
    observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
    log('Drawer watcher attached');
  }
  
  /**
   * Pausa polling när tabben inte är aktiv (sparar resurser)
   */
  function watchVisibility() {
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        stopPolling();
      } else {
        updatePolling();
        // Kör en check direkt när användaren kommer tillbaka
        if (shouldPoll()) {
          setTimeout(runCheck, 500);
        }
      }
    });
  }
  
  /**
   * Init
   */
  function init() {
    injectStyles();
    updatePolling();
    watchDrawer();
    watchVisibility();
    log('Stock indicator initialized');
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();